export const campaignSegmentType = {
  klaviyo: "klaviyo",
  shopify: "shopify",
  hubspot: "hubspot",
  simioSegment: "simioSegment",
};
